import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Coins } from "lucide-react";
import { adminGetFxRate, adminSetFxRate } from "@/lib/api";

export const FxRateCard = () => {
  const [rate, setRate] = useState("");
  const [plans, setPlans] = useState([]);
  const [saving, setSaving] = useState(false);

  const load = () => adminGetFxRate().then((r) => { setRate(String(r.usd_mxn_rate)); setPlans(r.plans || []); }).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    const v = parseFloat(rate);
    if (!v) return toast.error("Tipo de cambio inválido");
    setSaving(true);
    try { await adminSetFxRate(v); toast.success("Tipo de cambio actualizado"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "No se pudo guardar"); }
    finally { setSaving(false); }
  };

  return (
    <div className="mt-10 bg-[#0a0a0a] border border-white/10 rounded-2xl p-5 flex flex-col md:flex-row md:items-center gap-4" data-testid="admin-fx-card">
      <div className="flex items-center gap-2 text-white/50 text-[10px] font-mono uppercase tracking-widest"><Coins size={14} className="text-[#ccff00]" /> Tipo de cambio para SPEI</div>
      <div className="flex items-center gap-2">
        <span className="text-white/40 text-sm">1 USD =</span>
        <input value={rate} onChange={(e) => setRate(e.target.value.replace(/[^0-9.]/g, ""))} inputMode="decimal" className="w-24 bg-black/60 border border-white/10 rounded-xl px-3 py-2 text-sm outline-none" data-testid="admin-fx-input" />
        <span className="text-white/40 text-sm">MXN</span>
        <button onClick={save} disabled={saving} className="px-4 py-2 rounded-full bg-[#ccff00] text-black text-[10px] font-mono uppercase tracking-widest disabled:opacity-50" data-testid="admin-fx-save">{saving ? "…" : "Guardar"}</button>
      </div>
      <div className="flex flex-wrap gap-3 md:ml-auto text-[11px] font-mono text-white/60" data-testid="admin-fx-preview">
        {plans.map((p) => <span key={p.key}>{p.name}: ${p.price_usd} USD ≈ ${p.price_mxn?.toFixed(2)} MXN</span>)}
      </div>
    </div>
  );
};
